
import React from 'react';
import { Check } from 'lucide-react';

interface BenefitProps {
  title: string;
  description: string;
}

const Benefit = ({ title, description }: BenefitProps) => {
  return (
    <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6">
      <div className="flex items-start gap-4 mb-3">
        <div className="bg-green-500/20 rounded-full p-1 flex-shrink-0">
          <Check className="h-5 w-5 text-green-400" />
        </div>
        <h3 className="text-xl font-bold text-white">{title}</h3>
      </div>
      <p className="text-white/80 pl-9">{description}</p>
    </div>
  );
};

const StrategyBenefits = () => {
  const benefits = [
    {
      title: "Confidence",
      description: "Make AI Decisions Backed by Expertise. Move forward with a plan you can trust — designed by AI and legal strategy experts."
    },
    {
      title: "Clarity",
      description: "Get a Simple, Actionable Roadmap. No jargon, no chaos — just a clear path your team can follow immediately."
    },
    {
      title: "Client Trust",
      description: "Protect Your Reputation and Stay Compliant. Use AI responsibly and ethically, safeguarding the standards your clients expect."
    },
    {
      title: "Competitive Advantage",
      description: "Lead the Firms That Hesitate. Show your clients, partners, and team that you're proactive, prepared, and future-ready."
    }
  ];

  return (
    <section className="py-16 px-6 relative bg-gradient-to-b from-background to-background/90">
      <div className="container mx-auto max-w-6xl">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Why Your Firm Needs a Strategic <span className="text-gradient">AI Plan</span> Now
          </h2>
          
          <p className="text-lg text-white/80">
            At DocketLabs, we work closely with small and mid-sized law firms facing the same AI-driven challenges as larger competitors. A clear, practical AI strategy — designed specifically for your firm — helps you protect your client relationships, stay competitive, and move forward with confidence.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-6">
          {benefits.map((benefit, index) => (
            <Benefit 
              key={index}
              title={benefit.title}
              description={benefit.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StrategyBenefits;
